import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=1df4e700&"
import script from "./GroupCreate.vue?vue&type=script&lang=ts&"
export * from "./GroupCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports